import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthService } from '@core/services/auth.service';
import { TokenService } from '@core/services/token.service';
import { getLanguage } from '@core/utils';

import { environment as env } from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly tokenService = inject(TokenService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};

    if (!request.url.includes(env.api.refresh)) {
      if (request.url.includes(env.signerPath)) {
        headers = {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          charset: 'utf-8',
        };
      }
      const lang = request.headers.get('Current-Language');
      headers = {
        setHeaders: {
          Authorization: `Bearer ${this.getToken(request.url)}`,
          'Current-Language': lang ?? getLanguage(),
          ...headers,
        },
      };
    }

    const tokenReq = request.clone(headers);

    return next.handle(tokenReq);
  }

  private getToken(url: string): string {
    if (url.includes(env.api.hello)) {
      return this.tokenService.getHelloToken();
    }

    if (
      ((url.includes(env.api.identities) || url.includes(env.api.forgotPassword)) &&
        !url.includes(env.api.logout) &&
        !url.includes('identities/refresh-token')) ||
      url.includes(env.api.connectionApplications)
    ) {
      return this.authService.temporaryToken;
    }

    return this.tokenService.accessToken;
  }
}
